module.exports = __webpack_public_path__ + "static/media/hero-artist-in-grand-dining.4afe4012.jpg";